import axios from 'axios';
import type { FeedbackReason } from '@/components/market-sizing/detail/feedback/reasons';
import {
  MarketSizingCreateInput,
  MarketSizingFeedbackType,
  MarketSizingJob,
  MarketSizingTopicCandidate,
  MarketSizingTopicCheckInput,
  MarketSizingTopicCheckResult,
  MarketSizingTrackingPage,
} from '@/types/marketSizing';

export const createMarketSizingJob = async (
  params: MarketSizingCreateInput,
): Promise<MarketSizingJob> => {
  const { data } = await axios.post<MarketSizingJob>('/market_sizing', params);
  return data;
};

export const updateMarketSizingTitle = async (
  uuid: string,
  title: string,
): Promise<MarketSizingJob> => {
  const { data } = await axios.put<MarketSizingJob>(
    `/market_sizing/${uuid}/title`,
    { title },
  );
  return data;
};

export const deleteMarketSizingJob = async (uuid: string): Promise<void> => {
  await axios.delete(`/market_sizing/${uuid}`);
};

export const retryMarketSizingJob = async (
  uuid: string,
): Promise<MarketSizingJob> => {
  const { data } = await axios.post<MarketSizingJob>(
    `/market_sizing/${uuid}/retry`,
  );
  return data;
};

export const checkMarketSizingTopic = async (
  params: MarketSizingTopicCheckInput,
): Promise<MarketSizingTopicCandidate[]> => {
  const { data } = await axios.post<MarketSizingTopicCheckResult>(
    '/market_sizing/check_topic',
    params,
  );
  return data.candidates;
};

export const createMarketSizingFeedback = async (params: {
  uuid: string;
  feedback_type: MarketSizingFeedbackType;
  reasons: FeedbackReason[];
  comment: string;
  // feedback_submit の計測はサーバ側で発火するため page 情報を渡す
  page: MarketSizingTrackingPage;
}): Promise<void> => {
  await axios.post(`/market_sizing/${params.uuid}/feedbacks`, {
    feedback_type: params.feedback_type,
    reasons: params.reasons,
    comment: params.comment,
    page: params.page,
  });
};
